// extracted by mini-css-extract-plugin
export default {"button":"secondary__button___PShqK primary__button___frFdc base__button___zT0JW"};